<template>
  <div class="payment_result">
    <el-dialog :show-close="false" :visible.sync="dialogVisible" width="370px">
      <div class="acea-row row-column row-middle">
        <div class="pic"><img
            :src="pay === 'success' ? require('../../assets/images/paysuccessful.png') : require('../../assets/images/payFailed.png')">
        </div>
        <div class="status font-color">{{ pay === 'success' ?
          $t(`page.orderPayStatus.success`) : $t(`page.orderPayStatus.fail`)}}</div>
        <div class="tips">{{ pay === 'success' ? $t('page.paymentResult.successTip') : $t('page.paymentResult.failTip') }}</div>
        <el-button type="primary" @click="goList">{{ $t('page.paymentResult.confirm') }}</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import { getCurrentToken, isGuestToken } from '@/utils/guestToken';
export default {
  name: "order_sure",
  data() {
    return {
      dialogVisible: true,
      pay: '',
      orderid: ''
    }
  },
  created() {
    // 从链接中拿到pay和orderid
    const urlParams = new URLSearchParams(window.location.search);
    const pay = urlParams.get('pay');
    const orderid = urlParams.get('orderid');
    this.pay = pay;
    this.orderid = orderid;
  },
  methods: {
    goList() {
      let token = getCurrentToken();
      if (!isGuestToken(token) && this.pay == 'success') {
        this.$router.push({ path: '/users/order_list?orderStatus=1' });
      } else {
        this.$router.push({ path: '/' });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.payment_result {
  height: 400px;

  ::v-deep.el-dialog__header {
    padding: 0;
  }

  ::v-deep.el-dialog__body {
    padding: 49px 0 43px 0;
  }

  .status {
    font-size: 20px;
    font-family: Arial-BoldMT, Arial;
    font-weight: bold;
  }

  .tips {
    font-size: 16px;
    font-family: ArialMT;
    color: #999999;
    margin: 24px 0;
  }
}

.pic {
  width: 165px;
  height: 165px;
  margin-bottom: 30px;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
